import { FORM_DATATYPES } from '../../../components/auto-form-modal/AutoForm';

/**
 * Prepares field data for dropdown fields based on template metadata
 * @param templateMetadata The template metadata containing field definitions
 * @returns Object mapping field ids to their choices
 */
export function extractDropdownFields(templateMetadata: any[]): Record<string, Array<{ id: string; content: string }>> {
  const dropdownFields: Record<string, Array<{ id: string; content: string }>> = {};

  templateMetadata.forEach((field) => {
    if (field.dataType === FORM_DATATYPES.MULTIPLECHOICE && Array.isArray(field.choices)) {
      dropdownFields[field.id] = field.choices;
    }
  });

  return dropdownFields;
}
